export { default } from './PageTitle';
export * from './StaticPageTitle';
